// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
:root {
  --digitalization-color: #5AA4F4; 
  --green-revolution-color: #76C17D; 
  --sustainable-mobility-color: #F7857A; 
  --education-color: #9E82C3; 
  --inclusion-color: #F7A1AC; 
  --health-color: #FEEA8C;
}

.pnrr-1 { background-color: var(--digitalization-color); }
.pnrr-2 { background-color: var(--green-revolution-color); }
.pnrr-3 { background-color: var(--sustainable-mobility-color); }
.pnrr-4 { background-color: var(--education-color); }
.pnrr-5 { background-color: var(--inclusion-color); }
.pnrr-6 { background-color: var(--health-color); }`, "",{"version":3,"sources":["webpack://./src/assets/css/Pnrr.css"],"names":[],"mappings":";AACA;EACE,+BAA+B;EAC/B,iCAAiC;EACjC,qCAAqC;EACrC,0BAA0B;EAC1B,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA,UAAU,6CAA6C,EAAE;AACzD,UAAU,+CAA+C,EAAE;AAC3D,UAAU,mDAAmD,EAAE;AAC/D,UAAU,wCAAwC,EAAE;AACpD,UAAU,wCAAwC,EAAE;AACpD,UAAU,qCAAqC,EAAE","sourcesContent":["\n:root {\n  --digitalization-color: #5AA4F4; \n  --green-revolution-color: #76C17D; \n  --sustainable-mobility-color: #F7857A; \n  --education-color: #9E82C3; \n  --inclusion-color: #F7A1AC; \n  --health-color: #FEEA8C;\n}\n\n.pnrr-1 { background-color: var(--digitalization-color); }\n.pnrr-2 { background-color: var(--green-revolution-color); }\n.pnrr-3 { background-color: var(--sustainable-mobility-color); }\n.pnrr-4 { background-color: var(--education-color); }\n.pnrr-5 { background-color: var(--inclusion-color); }\n.pnrr-6 { background-color: var(--health-color); }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
